"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLInput = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var URLInput = function (_a) {
    var _b = _a.routesAreValidInputs, routesAreValidInputs = _b === void 0 ? false : _b, //if we want react route declarations to be considered as 'valid' then set this to true
    validationPlugin = _a.validationPlugin, passValidationErrorToFormValidation = _a.passValidationErrorToFormValidation, content = _a.content, props = __rest(_a, ["routesAreValidInputs", "validationPlugin", "passValidationErrorToFormValidation", "content"]);
    var handleValidation = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var pluginResponse, successObj, response, successObj, err_1, successObj, errorObj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validationPlugin) return [3 /*break*/, 2];
                    return [4 /*yield*/, validationPlugin({
                            value: value,
                            content: content,
                            passValidationErrorToFormValidation: passValidationErrorToFormValidation,
                        })];
                case 1:
                    pluginResponse = _a.sent();
                    if (pluginResponse)
                        return [2 /*return*/, pluginResponse];
                    _a.label = 2;
                case 2:
                    //else
                    //if routesAreValidInputs, then first validate for a route
                    if (routesAreValidInputs && value.substring(0, 1) === "/") {
                        successObj = { type: "success", msg: "valid route" };
                        if (passValidationErrorToFormValidation)
                            passValidationErrorToFormValidation(successObj.type);
                        return [2 /*return*/, successObj];
                    }
                    //else validate for a url
                    if (!/^https?:\/\//i.test(value)) {
                        value = "https://" + value;
                    }
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, fetch(value)];
                case 4:
                    response = _a.sent();
                    if (response.status !== 200)
                        throw new Error("");
                    successObj = { type: "success", msg: "valid url" };
                    if (passValidationErrorToFormValidation)
                        passValidationErrorToFormValidation(successObj.type);
                    return [2 /*return*/, successObj];
                case 5:
                    err_1 = _a.sent();
                    if (/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi.test(value)) {
                        successObj = { type: "success", msg: "valid url" };
                        if (passValidationErrorToFormValidation)
                            passValidationErrorToFormValidation(successObj.type);
                        return [2 /*return*/, successObj];
                    }
                    errorObj = { type: "error", msg: "Enter a valid url..." };
                    if (passValidationErrorToFormValidation)
                        passValidationErrorToFormValidation(errorObj.type);
                    return [2 /*return*/, errorObj];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(__1.TextInput, __assign({ type: "url", handleValidation: handleValidation, placeholder: "Enter a valid url..." }, props)));
};
exports.URLInput = URLInput;
